import { GreyGrey60, Primary13SemiBold } from '@sequencehq/core-components'

export const inputStyles = {
  paddingLeft: '12px'
}

export const fieldStyles = {
  label: {
    ...Primary13SemiBold,
    color: GreyGrey60
  }
}
